/**
 * 受付帳（ReceptionBook）用の追加項目同期システム
 * PropertySelectionGridと受付帳ポップアップ間で追加項目データを同期するためのユーティリティ
 */

import { createIndexedPropertyGridPopupSyncSystem } from "./createSyncSystem";

export const RECEPTION_BOOK_ADDITIONAL_FIELDS_UPDATE_EVENT =
  "updateReceptionBookAdditionalFields";

const { dispatch, addListener } =
  createIndexedPropertyGridPopupSyncSystem<string>(
    RECEPTION_BOOK_ADDITIONAL_FIELDS_UPDATE_EVENT
  );

/**
 * 受付帳の追加項目更新イベントを発火する
 * @param index 受付帳のインデックス
 * @param additionalFields 更新する追加項目（JSON文字列）
 */
export const dispatchReceptionBookAdditionalFieldsUpdate = (
  index: number,
  additionalFields: string
): void => {
  dispatch(index, additionalFields);
};

/**
 * 受付帳の追加項目更新イベントリスナーを追加する
 * @param targetIndex リスナーを登録する対象のインデックス
 * @param callback 追加項目が更新された際に呼び出されるコールバック関数
 * @returns クリーンアップ関数
 */
export const addReceptionBookAdditionalFieldsUpdateListener = (
  targetIndex: number,
  callback: (additionalFields: string) => void
): (() => void) => {
  return addListener(targetIndex, callback);
};
